import {ICurrency} from "@/interfaces/models/currency";

export interface MainStateInterface {
  prop: boolean;

  page?: object;
  user?: object;

  accessToken?: any;
  refreshToken?: any;

  symbols?: any;
  currencies?: ICurrency;
  countries?: any;
  bitflowCurrencies?: any;

  config?: any,
  permissions?: any;
  updates?: any;
}

const state: MainStateInterface = {
  prop: false,

  page: undefined,

  symbols: undefined,
  currencies: undefined,
  countries: undefined,
  bitflowCurrencies: undefined,

  accessToken: null,
  refreshToken: null,

  user: {
    loggedIn: false,
    accountId: null,
    email: null,
  },

  permissions: new Set(),

  updates: null
};

export default state;
